import React, { useEffect } from "react";
import { getStoreChecker, toTitleCase, toFixedVal } from "../../utils/utils";
import { useLazyQuery } from "@apollo/client";
import { GET_DEFAULT_LOCATION } from "../../graphql/queries";
import { connect } from "react-redux";
import ErrorMessage from "../ErrorMessage";
import {
  DATA_FETCH_ERROR,
  ONLOAN_INVALID_STOREID_ERROR,
} from "../../common/constants";
import PropTypes from "prop-types";

const InventoryMerchDataRow = ({
  employeeInfo = {},
  dateMatrix,
  icitemNumber,
  icitemName,
  icnetOHInvUnitCount,
  icsalesUnitCount,
  icthreeWeekSalesUnitCount,
  icZeroSellingSkuReport,
}) => {
  const [selectedLocation, setSelectedLocation] = React.useState(
    JSON.parse(sessionStorage.getItem("selectedLocation"))
  );
  let selectedStoreId = localStorage.getItem("storeId");
  const activeStorechecker = getStoreChecker(selectedStoreId);
  const userEmail = employeeInfo.adUpn;
  const [getDefaultLocation, { error: locationError = {} }] = useLazyQuery(
    GET_DEFAULT_LOCATION,
    {
      context: {
        headers: {
          Authorization: localStorage.getItem("jwtToken"),
        },
      },
      onCompleted: (data) => {
        let { salesSummaryV2 } = data;
        if (selectedLocation.locationName === "NA") {
          setSelectedLocation({
            locationNo: salesSummaryV2?.location?.primaryLocationNumber,
            locationName: salesSummaryV2?.location?.primaryLocationName,
          });
          sessionStorage.setItem(
            "selectedLocation",
            JSON.stringify({
              locationNo: salesSummaryV2?.location?.primaryLocationNumber,
              locationName: salesSummaryV2?.location?.primaryLocationName,
            })
          );
        }
      },
    }
  );
  useEffect(() => {
    if (userEmail && (activeStorechecker === true || selectedStoreId === "")) {
      getDefaultLocation({
        variables: { request: { email: userEmail, storeId: selectedStoreId } },
      });
    }
  }, [userEmail, getDefaultLocation, selectedStoreId, activeStorechecker]);

  return (
    <>
      {locationError.message ? (
        <ErrorMessage
          statusCode={locationError?.networkError?.statusCode}
          message={DATA_FETCH_ERROR}
        />
      ) : null}
      {activeStorechecker === false && selectedStoreId ? (
        <ErrorMessage message={ONLOAN_INVALID_STOREID_ERROR} />
      ) : null}
      <div className="data-row-container">
        <div className="flex row">
          <div className="sku-title">
            {" "}
            {`${toTitleCase(icitemName)} ${icitemNumber}`}{" "}
          </div>
        </div>
        <div className="flex row">
          <div className="b-1-3 ic-merch-sales-container">
            <div className="ic-merch-sales-value">
              {icsalesUnitCount === "0" ? (
                <div className="zero-selling">
                  *{icsalesUnitCount}*
                </div>
              ) : (
                toFixedVal(icsalesUnitCount)
              )}
            </div>
          </div>
          <div className="b-1-3 ic-merch-sales-container">
            <div className="ic-merch-sales-value">
              {toFixedVal(icthreeWeekSalesUnitCount)}
            </div>
          </div>
          <div className="b-1-3 ic-merch-sales-container">
            <div className="ic-merch-sales-value">
              {toFixedVal(icnetOHInvUnitCount)}
            </div>
          </div>
        </div>
        <div className="border-row" />
      </div>
    </>
  );
};

InventoryMerchDataRow.propTypes = {
  employeeInfo: PropTypes.shape({ adUpn: PropTypes.string }),
  dateMatrix: PropTypes.string,
  icitemNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icitemName: PropTypes.string,
  icnetOHInvUnitCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icsalesUnitCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icthreeWeekSalesUnitCount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  icZeroSellingSkuReport: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
  ]),
};

const mapStateToProps = (state) => ({
  employeeInfo: state.auth.employeeInfo,
  dateMatrix: state.salesSummary.currentDateMatrix.value,
});

export default connect(mapStateToProps, undefined)(InventoryMerchDataRow);
